import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { SsoConnectionForManipulationDto } from '../types';
import { SsoConnectionKeys } from './ssoConnection.keys';

export const updateSsoConnection = (
  id: string | undefined,
  data: SsoConnectionForManipulationDto,
): Promise<void> => {
  if (id === null || undefined) {
    throw new Error('id is required');
  }
  return clients.admin.put(`/ssointegrations/${id}`, data);
};

export function useUpdateSsoConnection(
  id: string | undefined,
  options?: UseMutationOptions<void, AxiosError, SsoConnectionForManipulationDto>,
) {
  const queryClient = useQueryClient();

  return useMutation((data: SsoConnectionForManipulationDto) => updateSsoConnection(id, data), {
    onSuccess: () => {
      queryClient.invalidateQueries(SsoConnectionKeys.lists());
      queryClient.invalidateQueries(SsoConnectionKeys.details());
    },
    ...options,
  });
}
